import { foundationProgressRingStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
const linearGradient = 'url(#linear)';
export const zeroProgressRingStyles = (context, definition) => css `
  ${foundationProgressRingStyles(context, definition)}
  .indeterminate-indicator-1, .determinate {
    stroke: ${linearGradient};
  }
`;
